<template>
	<div v-if="first_location">
		<h3 class="secondary-title">Location</h3>
		<div class="company-location rounded-md overflow-hidden">
			<div ref="job_map" class="w-full h-96"></div>
		</div>
	</div>
</template>

<script>
	import Map_Styles from '@/config/map_styles.js';

	export default {
		props: {
			location_list: {
				type: [String]
			}
		},

		data() {
			return {
				first_location: false
			}
		},

		mounted() {
			let locations;

			if (typeof this.location_list == 'string') {
				locations = JSON.parse(this.location_list);
			} else {
				locations = this.location_list;
			}

			console.log({locations});

			if (locations.length > 0) {
				if (locations[0].lat && locations[0].lng) {
					this.first_location = locations[0];
				}
			}

			if (this.first_location) {
				this.$nextTick(() => {
					this.initMap();
				})
			}
		},

		methods: {
			// Initialize and add the map
			initMap() {
			  // The location of the job
			  const loc_center = { lat: this.first_location.lat, lng: this.first_location.lng };
			  const map = new google.maps.Map(this.$refs.job_map, {
			    zoom: 12,
			    center: loc_center,
			    styles: Map_Styles,
			    disableDefaultUI: true,
			  });
			  const marker = new google.maps.Marker({
			    position: loc_center,
			    map: map,
			    icon: {
			      path: 'M14.3485 0C-3.35646 2.09836 0.315666 19.1475 0.315666 19.1475L6.54517 29.3115L15.3321 40L28.9714 22.0984C30.6763 19.2131 30.8075 12.0656 30.8075 12.0656C29.2993 0.131148 14.3485 0 14.3485 0ZM15.0698 22.8852C8.18452 23.082 7.39763 14.6885 7.39763 14.6885C8.05337 7.7377 14.2829 7.08197 16.0534 7.08197C16.3812 7.08197 16.5124 7.08197 16.5124 7.08197C25.8894 7.86885 23.9222 16.1967 23.9222 16.1967C22.6763 22.3607 17.037 22.9508 15.5288 22.9508C15.2009 22.8852 15.0698 22.8852 15.0698 22.8852Z',
			      fillColor: "#EB5D4B",
			      fillOpacity: 1,
			      anchor: new google.maps.Point(
			        15, // width
			        20 // height
			      ),
			      strokeWeight: 0,
			      strokeColor: "#ffffff",
			      scale: 1,
			    },
			  });
			}
		},
	}
</script>
